<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-else>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <span class="mb-4">Olá, Cooperado(a)!</span>
            <span class="mb-2">No dia 24 de abril de 2023 foi sancionada a Lei 14.553, que determina <strong>a inclusão sobre as informações de raça em cadastros de trabalhadores.</strong> de acordo com o eSocial, a informação deve ser autoclassificada pelo(a) próprio(a) trabalhador(a).</span>
            <span>Visando cumprir esta nova lei a regulamentação das normas do eSocial, selecione a sua <strong>Caracteristica Física</strong> no campo abaixo:</span>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <b-form-group class="mb-5" label="Características Físicas">
                <multiselect
                  v-model="campo.selectCaracteristasFisicas"
                  placeholder="Selecione"
                  :show-labels="false"
                  :allow-empty="false"
                  label="nm_raca_cor"
                  :options="optionCaracFisica"
                  :max-height="150"
                >
                  <span slot="noResult">Nenhum resultado encontrado.</span>
                </multiselect>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="mt-1 d-flex justify-content-end">
              <b-button
                size="md"
                class="me-1"
                variant="success"
                @click="salvarDados()"
                data-tooltip="Salvar"
                data-tooltip-location="left"
              >
                <i class="mdi mdi-content-save"></i>
                Salvar
              </b-button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  </template>
    
  <script>
  import PageHeader from "@/components/page-header";
  import Multiselect from "vue-multiselect";

  export default {
    components: {
      PageHeader,
      Multiselect,
    },

    data() {
      return {
        title: "Regularização E-social",
        items: [
          {
            text: "Perfil Pessoal",
            active: false,
          },
        ],
        loading: true,
        optionCaracFisica: [],
        campo: {
          selectCaracteristasFisicas: {},
        },
      };
    },

    async created() {
      window.scrollTo(0, 0);
      this.$tools.fecharMenu();
      await this.preencheLookUp();
      // await this.verificarSituacaoCadastral();
    },

    methods: {
      async verificarSituacaoCadastral(){
        try {
          const respSituacao = await this.$http.get(
            "api/cadastroCandidato/atualizaRacaCor"
          );
          if(respSituacao.data.status){
            this.$store.commit("VALIDA_ESOCIAL", true);
            this.$router.push("/");
          } else {
            await this.preencheLookUp();
          }
        } catch (error) {
          console.error("Erro", error);
        }
      },
      async preencheLookUp(){
        try{
          const [
            respRacaCor,
          ] = await Promise.all([
            this.$http.get("api/cadastroCandidato/buscarRacaCor"),
          ]);

          this.optionCaracFisica = respRacaCor.data.map((item) => ({
            ...item,
            nm_raca_cor:
              item.nm_raca_cor.charAt(0).toUpperCase() +
              item.nm_raca_cor.slice(1).toLowerCase(),
          }));
        } catch (error){
          console.error("Erro", error);
        } finally {
          this.loading = false;
        }
      },
      salvarDados(){
        var item = {
          CaracFisicas: this.campo.selectCaracteristasFisicas.sq_raca_cor
        };

        this.$http
          .post("api/cadastroCandidato/insertRacaCor", item)
          .then(() => {
            this.$tools.alerta("Atualizado com sucesso", "success");
            this.$store.commit("VALIDA_ESOCIAL", true);
            this.$router.push("/");
          })
          .catch((err) => {
            this.$tools.alerta(err.response.data.message, "error");
          })
        }
    },
  };
</script>